import React from 'react';
import clsx from 'clsx';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {CommonRuleEditorProps} from '../../../types';
import {
	attributeHistoryRuleEditorClasses,
	getAttributeHistoryRuleEditorUtilityClass,
	AttributeHistoryRuleEditorClasses,
	ATTRIBUTE_HISTORY_RULE_EDITOR_CLASS_NAME,
} from './attributeHistoryRuleEditorClasses';

export type AttributeHistoryRuleEditorOwnerState = WithClasses<
	AttributeHistoryRuleEditorClasses,
	{}
>;

const useUtilityClasses = (
	ownerState: AttributeHistoryRuleEditorOwnerState,
) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(
		slots,
		getAttributeHistoryRuleEditorUtilityClass,
		classes,
	);
};

const AttributeHistoryRuleEditorRoot = styled('div', {
	name: ATTRIBUTE_HISTORY_RULE_EDITOR_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flex: '1 1 auto',
}));

export type AttributeHistoryRuleEditorProps = WithClasses<
	AttributeHistoryRuleEditorClasses,
	CommonRuleEditorProps & {}
>;

const AttributeHistoryRuleEditorInner = ({
	classes: _classes,
	className,
}: AttributeHistoryRuleEditorProps) => {
	const ownerState: AttributeHistoryRuleEditorOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<AttributeHistoryRuleEditorRoot
			className={clsx(classes.root, className)}
		></AttributeHistoryRuleEditorRoot>
	);
};

export const AttributeHistoryRuleEditorPrimitive =
	AttributeHistoryRuleEditorInner;

export const AttributeHistoryRuleEditor = AttributeHistoryRuleEditorPrimitive;

export default AttributeHistoryRuleEditor;
